var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ChatInput from './ChatInput';
import { handleMessageSend } from '../../redux/actions/messages';
import { useAppDispatch } from '../../redux';
const ChatInputContainer = props => {
    const appDispatch = useAppDispatch();
    const propsWithRedux = Object.assign(Object.assign({}, props), { handleMessageSend: (handleMessageSendProps) => __awaiter(void 0, void 0, void 0, function* () { return yield appDispatch(handleMessageSend(handleMessageSendProps)).unwrap(); }) });
    return React.createElement(ChatInput, Object.assign({}, propsWithRedux));
};
export default ChatInputContainer;
//# sourceMappingURL=ChatInputContainer.js.map